import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileXls.tsx
const IconFileXls = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#5eb557",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm8.719 5.98q.384.186.936.186.39 0 .696-.096.306-.102.51-.282.21-.18.318-.432t.108-.552q0-.546-.312-.84-.312-.3-.96-.402l-.414-.066q-.264-.042-.384-.138-.114-.096-.114-.312 0-.192.15-.3t.456-.108q.324 0 .534.114.216.108.366.282l.606-.612a1.7 1.7 0 0 0-.618-.438q-.36-.15-.834-.15-.372 0-.666.096a1.4 1.4 0 0 0-.492.258 1.2 1.2 0 0 0-.306.402 1.2 1.2 0 0 0-.108.516q0 .528.306.846.312.318.978.402l.414.054q.294.042.39.162a.43.43 0 0 1 .096.288.46.46 0 0 1-.162.366q-.162.138-.498.138a1.35 1.35 0 0 1-1.05-.48l-.6.606q.27.3.654.492m-4.16.114h-1.055l-.906-1.542h-.018l-.882 1.542h-.984l1.344-2.166-1.278-2.022h1.062l.816 1.416h.018l.828-1.416h.984l-1.29 2.04zm.558 0v-4.188h.912v3.378h1.596v.81z",
			clipRule: "evenodd"
		})
	]
});
var IconFileXls_default = forwardRef(IconFileXls);
//#endregion
export { IconFileXls_default as default };
